import type {
  AppFlyoutAnchorProps,
  AppFlyoutAnchorState,
} from "./AppFlyoutAnchor.types";
import { useControlledContextualMenuByMenuButton } from "./useControlledContextualMenuByMenuButton";

export const useAppFlyoutAnchorState = (
  props: AppFlyoutAnchorProps,
  state: AppFlyoutAnchorState
): AppFlyoutAnchorState => {
  useControlledContextualMenuByMenuButton(props, state);

  // Create menuHidden prop to pass to MenuButton
  // This is for styling, to know if the MenuButton should style in the "expanded" state
  state.menuButton.menuHidden = state.menu.hidden;

  return state;
};
